import api from "./api";

// "Configurar Integração" (conector de cotação) — PO1-2550/H5.
// Endpoints no backend_hub (módulo transportadoras).

export async function getIntegracao(transportadoraId, embarcadorId) {
  const { data } = await api.get(`/transportadoras/${transportadoraId}/integracao`, {
    params: embarcadorId ? { embarcadorId } : {},
  });
  return data;
}

export async function salvarIntegracao(transportadoraId, { embarcadorId, valores }) {
  const { data } = await api.put(`/transportadoras/${transportadoraId}/integracao`, {
    embarcadorId,
    valores,
  });
  return data;
}

export async function testarConexao(transportadoraId, { embarcadorId }) {
  const { data } = await api.post(`/transportadoras/${transportadoraId}/integracao/testar`, {
    embarcadorId,
  });
  return data;
}

// PO1-3484: o Autopilot monta o e-mail pedindo à transportadora os dados vazios do conector.
export async function montarEmailAutopilot(transportadoraId, { embarcadorId, remetenteNome }) {
  const { data } = await api.post(`/transportadoras/${transportadoraId}/integracao/email-autopilot`, {
    embarcadorId,
    remetenteNome,
  });
  return data;
}

// Serviços contratados do conector (multiselect do campo de produtos). PO1-2554.
export async function listarServicosConector(transportadoraId, embarcadorId) {
  const { data } = await api.get(`/transportadoras/${transportadoraId}/integracao/servicos`, {
    params: { embarcadorId },
  });
  return data;
}
